import React, { useEffect, useReducer, useState} from 'react';
import {Container, Row,Button, Nav, Accordion} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import $ from "jquery"
import "../stylesheets/style.css"
import "../stylesheets/webapp.css"
import "../js/main.js"
import Testimonials from './Testimonials';
import Faq from './Faq';
import Contact from './Contact'

const RecoverPassword = () => {
    useEffect(() =>{
        document.title = "Recover Password | Earth VIII Apartments"
    },[])
    const [Notify, SetNotify] = useState("")

    const recoverPassword = () =>{
      var settingsthree = {
          beforeSend: function(){
              SetNotify("Processing...")
          },
          "url": "https://earthvii-api.herokuapp.com/v1/registration/password_reset_email/",
          "method": "POST",
          "timeout": 0,
          //  "headers": { "X-ApiKey": "SfeILETE0TcCFOziCtTXBPxfqsmTR6aO5F+3cJRmobMf/w8HEVw7xqAvAyNPlD0O"},
           "data":
           {
               "email": document.getElementById("email").value, 
             
           },
           error: function(xhr, status, error) {
             console.log(xhr.status)

             if(xhr.status==400) {
              console.log(xhr.responseJSON)
              SetNotify("**Invalid E-mail Address")
              // alert(thrownError);
          }

          if(xhr.status==404) {
            console.log(xhr.responseJSON)
            SetNotify("**E-mail does not exist")
            // alert(thrownError);
        }
      },
           complete: function(){
          
          }
          }
          $.ajax(settingsthree).done(function (responsetwo) {
              console.log(responsetwo)
      
                SetNotify("Password reset email successfully sent.")
                document.getElementById("email").value = ""
       
            })
  }



    return (
      
      <div>
<div>
<Header/>
<div className='signinbody'>
<div className="row">

<div class="col-md-6">

</div>

<div class="col-md-4 signinformbox">
  <h2 className='signinhead'>Recover password</h2>
  <p className='signinsubtitle fordesktoponly'>Seems you have forgotten your password, Lets<br/> assist you in getting a new one</p>
  <p className='signinsubtitle formobileonly'>Seems you have forgotten your password, Lets assist you in getting a new one</p>



<div className="row">
<div className='col-md-2'>
  
</div>

<div className='col-md-8'>
<div className=''>


  <div class="form-group mobilesigninforngroup">
    <label className='signinlabel2' for="">Email Address</label>
    <input type="" class="form-control form-control-lg hminput" id="email" placeholder="E-mail Address"/>
  </div>




</div>
<p style={{textAlign:"center"}}>{Notify}</p>
<div className="d-grid">
<button onClick={recoverPassword} class="signinbutton">Send recovery link</button>

</div>
<p>
<Nav.Link className="signinalready singninoptions mobilesigninforngroup" as={Link} to="/signup" eventKey="3" activeClassName="is-active" >New user ? Sign up here </Nav.Link>
  <Nav.Link className="signinalready singninoptions fpassword" as={Link} to="/recoverpassword" eventKey="3" activeClassName="is-active" >Forgot password?</Nav.Link>

</p>


</div>

<div className='col-md-2'>
  
</div>
</div>



</div>
</div>
  </div>

</div>


<br/>
<br/>
<br/>



    {/* <Footer/> */}
    </div>


    )
    
    
}


export {RecoverPassword as default}